//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular, { IPromise, ITimeoutService } from 'angular';

import template from './help-menu.html';

import { GaApi } from 'app/initialization/ga/ga-api';
import { BAZAARVOICE_CONTACT_SUPPORT_URL } from 'app/constants/support-links';

const menuItems = [
  {
    label: 'Help & Support',
    items: [
      {
        label: 'Knowledge Base',
        url: 'https://docs.bazaarvoice.com/articles/vibe/vibe',
      },
      {
        label: 'Contact Support',
        url: BAZAARVOICE_CONTACT_SUPPORT_URL,
      },
    ],
  },
  {
    label: 'Resources',
    items: [
      {
        label: 'Get Started',
        url: 'https://docs.bazaarvoice.com/articles/vibe/get-started-with-vibe',
      },
      {
        label: 'Strategy Guides',
        url: 'https://support.bazaarvoice.com/s/topic/0TO2J000000kFbyWAE/social-commerce-strategy-guides',
      },
      {
        label: 'Product Updates',
        url: 'https://www.bazaarvoice.com/updates/',
      },
    ],
  },
];

// This class is set up to mimic the behavior of the settings menu. See settings-menu.ts for more context
export class HelpMenu {
  public opened: boolean; // This is used to control the scrim
  public menuItems: object;
  private closeTimeout: IPromise<void>;
  private helpMenuViewedTimeout: IPromise<void>;

  constructor(
    private $timeout: ITimeoutService,
    private TrackingService: GaApi,
  ) {}

  public $onInit(): void {
    this.opened = false;
    this.closeTimeout = null;
    this.menuItems = menuItems;
  }

  public onDropdownMouseEnter(): void {
    this.opened = true;

    if (this.closeTimeout) {
      this.$timeout.cancel(this.closeTimeout);
      this.closeTimeout = null;
    }

    // Only record GA event if user hovers for over .5 seconds
    this.helpMenuViewedTimeout = this.$timeout(() => {
      this.TrackingService.recordEvent(
        this.TrackingService.CATEGORY_NAVIGATION3,
        this.TrackingService.ACTION_NAVIGATION3_TOP_NAV_HELP,
      );
    }, 500);
  }

  public close(): void {
    // This timeout keeps the dropdown open for .2 seconds while the user moves their cursor to it
    this.closeTimeout = this.$timeout(() => {
      this.opened = false;
      this.closeTimeout = null;

      this.$timeout.cancel(this.helpMenuViewedTimeout);
      this.helpMenuViewedTimeout = null;
    }, 200);
  }

  public recordClick(linkLabel: string): void {
    this.close();

    this.TrackingService.recordEvent(
      this.TrackingService.CATEGORY_NAVIGATION3,
      this.TrackingService.ACTION_NAVIGATION3_TOP_NAV_HELP,
      linkLabel,
    );
  }
}

angular.module('curalate').component('helpMenu', {
  template,
  bindings: {},
  controller: ['$timeout', 'TrackingService', HelpMenu],
});
